import {useForm} from "react-hook-form";
import {useEffect} from "react";
import {usePolTranslation} from "v4/hooks/usePolTranslation";

export default function useFormRender(methods, onSubmit, formErrors) {
    const {t} = usePolTranslation();
    const formRenderMethods = methods ?? useForm({mode: 'onChange'});

    const handleSubmit = formRenderMethods.handleSubmit(data => onSubmit(data, formRenderMethods));

    useEffect(() => {
        // Form errors from Core API
        if (formErrors?.type === 'client-error:unprocessable-entity') {
            const {data} = formErrors;

            data.fields.forEach(field => {
                formRenderMethods.setError(field.name, {
                    type: 'invalidForm',
                    message: field.messages.map(m => t(m)).join('\n')
                });
            });
            return;
        }

        // Form v4
        if (!formErrors?.errors) return;

        Object.entries(formErrors.errors ?? {}).forEach(([key, value]) => {
            if (['_default', '_form'].includes(key)) return;

            const {messages = []} = value;

            if (messages.length === 0) return;

            formRenderMethods.setError(key, {type: 'invalidForm', message: messages.map(m => t(m)).join('\n')});
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formErrors, formRenderMethods]);

    return {
        formRenderMethods,
        handleSubmit,
    }
}
